// import React, { useState } from "react";
// import Input from "../Components/DynamicComp/Input";
// import Button from "../Components/DynamicComp/Button";
// import { postData } from "../global/Globalapi";
// // import { toast } from "react-toastify";
// import swal from "sweetalert";
// const ForgotPassword = () => {
//   const [email, setEmail] = useState("");

//   const handleSubmit = async () => {
//     if (!email) {
//       swal("Email is required");
//       return;
//     }

//     try {
//       await postData("/forgot-password", { email });
//       swal("Reset link sent to your email");
//     } catch (error) {
//      swal(error?.response?.data?.message || "Failed to send reset link");
//     }
//   };

//   return (
//     <div className="max-w-md mx-auto mt-20 p-6 border rounded">
//       <h2 className="text-xl font-semibold mb-4">Forgot Password</h2>

//       <Input
//         type="email"
//         placeholder="Enter your email"
//         value={email}
//         onChange={(e) => setEmail(e.target.value)}
//       />

//       <Button className="mt-4 w-full" onClick={handleSubmit}>
//         Send Reset Link
//       </Button>
//     </div>
//   );
// };

// export default ForgotPassword;
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Input from "../Components/DynamicComp/Input";
import Button from "../Components/DynamicComp/Button";
import { postData } from "../global/Globalapi";
import swal from "sweetalert";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async () => {
    if (!email) {
      swal("Email is required");
      return;
    }

    setLoading(true);
    try {
      await postData("/forgot-password", { email });
      swal("Reset link sent to your email");
      setEmail("");
    } catch (error) {
      swal(error?.response?.data?.message || "Failed to send reset link");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* 🔙 Back Button (OUTSIDE UI) */}
      <div className="max-w-md mx-auto mt-10">
        <button
          onClick={() => navigate(-1)}
           className="px-4 py-2 text-sm w-auto"
        >
          ← Back
        </button>
      </div>

      {/* ❌ UI NOT CHANGED */}
      <div className="max-w-md mx-auto mt-4 p-6 border rounded">
        <h2 className="text-xl font-semibold mb-4">Forgot Password</h2>

        <Input
          type="email"
          placeholder="Enter your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        <Button
          className="mt-4 w-full"
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading ? "Sending..." : "Send Reset Link"}
        </Button>
      </div>
    </>
  );
};

export default ForgotPassword;
